<template>
  <div>
    <v-container fill-height>
        <v-layout
        wrap
        pb-5
        >
        <v-flex
            md4
            hidden-sm-and-down
        >
            <v-card
            img="/static/about1.png"
            height="250px"
            />
        </v-flex>

        <v-flex
            xs12
            md8
            :pl-5="$vuetify.breakpoint.mdAndUp"
        >
            <h2
            class="title mb-3"
            v-text="$t('About.heading1')"
            />
            <p v-text="$t('About.headingText1')" />
        </v-flex>
        </v-layout>
    </v-container>
    <v-container>
        <v-layout
        wrap
        pb-5
        >
        <v-flex
            xs12
            md8
            :pl-5="$vuetify.breakpoint.mdAndUp"
        >
            <h2
            class="title mb-3"
            v-text="$t('About.heading2')"
            />
            <p v-text="$t('About.headingText2')" />
        </v-flex>

        <v-flex
            md4
            hidden-sm-and-down
        >
            <v-card
            img="/static/about2.png"
            height="250px"
            />
        </v-flex>

        </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Services',
      meta: [
        { name: 'description', content: 'Customized vue-cli templates for Vue and Vuetify' }
      ]
    },
    computed: {
      testimonial () {
        return {
          quote: this.$t('Services.testimonial.quote'),
          author: this.$t('Services.testimonial.author'),
          title: this.$t('Services.testimonial.title')
        }
      }
    }
  }
</script>
